import { render, staticRenderFns } from "./verify.vue?vue&type=template&id=09835816&scoped=true&"
import script from "./verify.vue?vue&type=script&lang=js&"
export * from "./verify.vue?vue&type=script&lang=js&"
import style0 from "./verify.vue?vue&type=style&index=0&id=09835816&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09835816",
  null
  
)

export default component.exports